(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-ingredients"] && !Shopify.designMode) return;
  try {
    
  (()=>{const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');const init=root=>{if(root.dataset.ready)return;root.dataset.ready='1';const buttons=[...root.querySelectorAll('[data-eai-option]')],media=[...root.querySelectorAll('[data-eai-media]')],title=root.querySelector('.eai__note h3'),copy=root.querySelector('.eai__note p');if(!buttons.length||!media.length)return;let active=0,timer;const autoplay=root.dataset.autoplay==='true'&&!reduced.matches,interval=Math.max(3000,Number(root.dataset.interval||5000));const stop=()=>clearInterval(timer);const start=()=>{stop();if(autoplay)timer=setInterval(()=>show(active+1,false),interval)};const show=(index,restart=true)=>{active=(index+buttons.length)%buttons.length;buttons.forEach((button,i)=>{const selected=i===active;button.classList.toggle('is-active',selected);button.setAttribute('aria-pressed',String(selected))});media.forEach((item,i)=>{const selected=i===active;item.classList.toggle('is-active',selected);item.setAttribute('aria-hidden',String(!selected))});if(title)title.textContent=buttons[active].dataset.title;if(copy)copy.textContent=buttons[active].dataset.copy;if(restart)start()};buttons.forEach((button,index)=>{button.addEventListener('click',()=>show(index));button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){stop();show(index,false)}});button.addEventListener('focus',()=>{stop();show(index,false)})});root.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')start()});root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget))start()});document.addEventListener('visibilitychange',()=>document.hidden?stop():start());show(0,false);start()};document.querySelectorAll('[data-eai]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-eai]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvart-about-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.ea:not([data-ea-ready])');
    roots.forEach((root) => {
      root.dataset.eaReady = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = root.querySelectorAll('[data-ea-reveal]');
      if (reduceMotion || !('IntersectionObserver' in window)) {
        reveals.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
        reveals.forEach((item) => observer.observe(item));
      }
      const stage = root.querySelector('[data-ea-ingredients]');
      if (stage) {
        const title = stage.querySelector('[data-ea-note-title]');
        const copy = stage.querySelector('[data-ea-note-copy]');
        stage.querySelectorAll('[data-ea-ingredient]').forEach((button) => {
          button.addEventListener('click', () => {
            stage.querySelectorAll('[data-ea-ingredient]').forEach((item) => {
              item.classList.remove('is-active');
              item.setAttribute('aria-pressed', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-pressed', 'true');
            title.textContent = button.dataset.title;
            copy.textContent = button.dataset.copy;
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvart-craft-path-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateProgress = (section) => {
      const scroller = section.querySelector('[data-process-scroller]');
      const progress = section.querySelector('[data-process-progress]');
      if (!scroller || !progress) return;
      const range = scroller.scrollWidth - scroller.clientWidth;
      const position = range > 0 ? scroller.scrollLeft / range : 0;
      progress.style.width = `${25 + position * 75}%`;
    };

    const initialise = (section) => {
      if (section.dataset.processReady === 'true') return;
      const scroller = section.querySelector('[data-process-scroller]');
      if (!scroller) return;
      section.dataset.processReady = 'true';
      scroller.addEventListener('scroll', () => updateProgress(section), { passive: true });
      window.addEventListener('resize', () => updateProgress(section), { passive: true });
      updateProgress(section);
    };

    document.querySelectorAll('.elsvart-process').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.elsvart-process');
      if (section) initialise(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvart-editorial-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = (root) => {
    root.querySelectorAll('[data-elsvart-hero]').forEach((hero) => {
      if (hero.dataset.elsvartHeroReady === 'true') return;
      hero.dataset.elsvartHeroReady = 'true';
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
      };
      const restart = () => {
        window.clearInterval(timer);
        if (hero.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) {
          timer = window.setInterval(() => show(index + 1), Number(hero.dataset.delay));
        }
      };
      hero.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
      hero.querySelector('[data-hero-previous]')?.addEventListener('click', () => { show(index - 1); restart(); });
      restart();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvart-journal-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elsvart-journal-carousel')) {
    customElements.define('elsvart-journal-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-journal-track]');
        this.previousButton = this.querySelector('[data-journal-prev]');
        this.nextButton = this.querySelector('[data-journal-next]');
        if (!this.track) return;
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.updateButtons = this.updateButtons.bind(this);
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.updateButtons, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }
      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.updateButtons);
        this.resizeObserver?.disconnect();
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (this.track.clientWidth + gap), behavior: 'smooth' });
      }
      updateButtons() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= max - 2 || max <= 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvart-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elsvart-product-carousel')) {
    customElements.define(
      'elsvart-product-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');
          if (!this.track) return;

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          new ResizeObserver(() => this.updateButtons()).observe(this.track);
          this.updateButtons();
        }

        move(direction) {
          const card = this.track.querySelector('.epc__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        }

        updateButtons() {
          const end = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= end;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
